import AdminLayout from "@/views/admin/AdminLayout.vue"
import Reports from "@/views/admin/reports/ReportList.vue"
import IncomeStatements from "@/views/admin/reports/IncomeStatements.vue"
import BalanceSheet from "@/views/admin/reports/BalanceSheet.vue"
import CashFlow from "@/views/admin/reports/CashFlow.vue"
import SalesTaxes from "@/views/admin/reports/SalesTaxes.vue"
import IncomeByCustomer from "@/views/admin/reports/IncomeByCustomer.vue"
import PurchasesByVendor from "@/views/admin/reports/PurchasesByVendor.vue"
import CustomerAgedReceivables from "@/views/admin/reports/CustomerAgedReceivables.vue"
import VendorAgedPayables from "@/views/admin/reports/VendorAgedPayables.vue"
import AccountBalances from "@/views/admin/reports/AccountBalances.vue"
import TrialBalance from "@/views/admin/reports/TrialBalance.vue"
import AccountTransactions from "@/views/admin/reports/AccountTransactions.vue"

const routes = [
  {
    path: "/:lang/reports",
    component: AdminLayout,

    children: [
      {
        path: "",
        name: "Reports",
        meta: {
          title: "Reports.__Report",
          requireAuth: true,
          auth: 0
        },
        component: Reports
      },
      {
        path: "income-statements",
        name: "ReportIncomeStatements",
        meta: {
          title: "Reports.__IncomeStatements",
          requireAuth: true,
          auth: 0
        },
        component: IncomeStatements
      },
      {
        path: "balance-sheet",
        name: "ReportBalanceSheet",
        meta: {
          title: "Reports.__BalanceSheet",
          requireAuth: true,
          auth: 0
        },
        component: BalanceSheet
      },
      {
        path: "cash-flow",
        name: "ReportCashFlow",
        meta: {
          title: "Reports.__CashFlow",
          requireAuth: true,
          auth: 0
        },
        component: CashFlow
      },
      {
        path: "sales-tax",
        name: "ReportSalesTaxes",
        meta: {
          title: "Reports.__SalesTaxes",
          requireAuth: true,
          auth: 0
        },
        component: SalesTaxes
      },
      {
        path: "income-by-customer",
        name: "ReportIncomeByCustomer",
        meta: {
          title: "Reports.__IncomeByCustomer",
          requireAuth: true,
          auth: 0
        },
        component: IncomeByCustomer
      },
      {
        path: "customer-aged-receivables",
        name: "ReportAgedReceivables",
        meta: {
          title: "Reports.__AgedReceivables",
          requireAuth: true,
          auth: 0
        },
        component: CustomerAgedReceivables
      },
      {
        path: "purchase-by-vendor",
        name: "ReportPurchasesByVendor",
        meta: {
          title: "Reports.__PurchasesByVendor",
          requireAuth: true,
          auth: 0
        },
        component: PurchasesByVendor
      },
      {
        path: "vendor-aged-payables",
        name: "ReportAgedPayables",
        meta: {
          title: "Reports.__AgedPayables",
          requireAuth: true,
          auth: 0
        },
        component: VendorAgedPayables
      },
      {
        path: "account-balances",
        name: "ReportAccountBalances",
        meta: {
          title: "Reports.__AccountBalances",
          requireAuth: true,
          auth: 0
        },
        component: AccountBalances
      },
      {
        path: "trial-balance",
        name: "ReportTrialBalance",
        meta: {
          title: "Reports.__TrialBalance",
          requireAuth: true,
          auth: 0
        },
        component: TrialBalance
      },
      {
        path: "account-transactions",
        name: "ReportAccountTransactions",
        meta: {
          title: "Reports.__AccountTransactions",
          requireAuth: true,
          auth: 0
        },
        component: AccountTransactions
        // props: route => ({
        //     ...route.params
        // })
      }
    ]
  }
]

export default routes
